export const collapseAccordion = (element: HTMLDivElement, onEnd?: () => void) => {
    // get the height of the element's inner content, regardless of its actual size
    const accordionHeight = element.scrollHeight;

    // temporarily disable all css transitions
    const elementTransition = element.style.transition;

    element.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(() => {
        element.style.height = `${accordionHeight}px`;
        element.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(() => {
            element.style.height = '0px';
            if (onEnd) {
                onEnd();
            }
        });
    });
};

export const expandAccordion = (element: HTMLDivElement, onEnd?: () => void) => {
    // get the height of the element's inner content, regardless of its actual size
    const accordionHeight = element.scrollHeight;

    // have the element transition to the height of its inner content
    element.style.height = `${accordionHeight}px`;

    const onTransitionEnd = () => {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', onTransitionEnd);

        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = '';
        if (onEnd) { onEnd(); }
    };

    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener('transitionend', onTransitionEnd);
};

export default {
    collapseAccordion,
    expandAccordion
};
